import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const Header = () => {
  const [userInfo, setUserInfo] = useState({
    userName: '',
    userPasswordChangeYn: 'N',
  });

  useEffect(() => {
    Server.sendGet('user/info', {}, getUserInfo).then();
  }, []);

  const getUserInfo = res => {
    if (Common.isEmpty(res['resultObject'])) {
      // confirmAlert({
      //   title: 'Credentials do not exist.',
      //   buttons: [{
      //     label: 'Yes',
      //     onClick: () => {
      //       localStorage.removeItem('accessToken');
      //       localStorage.removeItem('refreshToken');
      //
      //       document.location.href = '/login';
      //     }
      //   }]
      // });
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      document.location.href = '/login';
    }

    setUserInfo(res['resultObject']);

    if (res['resultObject'].userPasswordChangeYn === 'N') {
      window.location.href = '/password';
    }
  };
  const moveRoot = () => {
    window.location.href = '/';
  };
  const logOut = () => {
    confirmAlert({
      title: 'Do you want to log out?',
      buttons: [{
        label: 'Yes',
        onClick: () => {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');

          document.location.href = '/login';
        }
      }, {
        label: 'No'
      }]
    });
  };

  return (
    <>
      <HeadWrap>
        <Inner>
          <LogoBox onClick={moveRoot}>
            <img src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/india_logo.webp' alt='UST India'/>
          </LogoBox>

          <UtilBox>
            <UserIn>
              <span>Hello. <strong>{userInfo?.userName}</strong></span>
            </UserIn>
            <UtilBtn>
              <BtnList onClick={logOut}>
                <BtnIc src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/logout_ic.webp'/>
              </BtnList>
            </UtilBtn>
          </UtilBox>
        </Inner>
      </HeadWrap>
    </>
  );
}

const HeadWrap = styled.div`
  position: relative;
  width: 100%;
  height: 65px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/head_deco.webp') top 50% left 0 no-repeat;
`;

const Inner = styled.div`
  padding-left: 120px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoBox = styled.div`
  position: relative;
`;

const UtilBox = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 0 25px;
`;

const UserIn = styled.div`
  & span {
    font-weight: 500;
    font-size: 16px;
    color: #777777;
  }

  & strong {
    font-weight: 500;
    font-size: 20px;
    color: #0072B9;
  }
`;

const UtilBtn = styled.ul`
  height: 100%;
  display: flex;
  align-items: center;
`;

const BtnList = styled.li`
  height: 100%;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 0;
  border-right: 0;
  background: #ffffff;
  cursor: pointer;
`;

const BtnIc = styled.img.attrs({ alt: 'Header Ic' })``;

export default Header;
